//COLOURS:
//--------------------------------------------------
//Primary:
// $dark-teal: #008788;
// $mid-teal: #51abaa;
// $bright-teal: #00c1bd;
// $light-teal: #bfefee;
// //Secondary:
// $quartz1: #6f6f6f;
// $quartz2: #808080;
// $quartz3: #a6a6a6;
// $quartz4: #e6e6e6;
// //Tertiary
// $sapphire: #0037c4;
// $emerald: #008e4a;
// $peridot: #5ad534;
// $topaz: #16baff;
// $citrine: #fecc00;
// $amber: #ff6909;
// $ruby: #ff0931;
// $amethyst: #5847b6;
// $torea-bay: #0b3093;
// //Other
// $white: #fff;
// $light-gray: #f7f7f7;
// $lighter-gray: #fcfcfc;
// $light-teal-divider: $light-teal;
// $mid-teal-divider: #80e0de;
// $sapphire-divider: $sapphire;
// $red: #FF0830;
// $black:#000;
// $almost-black: #273a3a;
// $light-blue-gray: #eaeff7;
// $amber-darker-border: #ba4112;
// $heading-font: "Moderat-Black";
// $subheading-font: "Moderat-Bold";
// /*$body-font: "Moderat-Regular";*/
// $body-font: "Moderat-light";
// $body-font-bold: "Moderat-Bold";
// $italic-font-part: "Italic";
// $bold-font-part: "Bold";
// $label-font: "Moderat-Medium";
// $light-font: "Moderat-Light";
// $button-font: "Moderat-Medium";
// $medium-font: "Moderat-Medium";
// $regular-font: "Moderat-Regular";
var defaultTheme = {
    colors: {
        cardColor: "#00c1bd", // $bright-teal
        pageColor: "#fcfcfc", // $lighter-gray
        textColor: "#273a3a", // $almost-black
        disabledTextColor: "#6f6f6f", // $quartz1
        linkColor: "#008788", // $dark-teal
        buttonColor: "#ff6909", // $amber
        buttonHoverColor: "#ba4112", // $amber-darker-border
        buttonTextColor: "#fff", // $white
        inputColor: "#fff", // $white
        agentColor: "#16baff", // $topaz
        botColor: "#bfefee", // $light-teal
        userColor: "#e6e6e6", // $quartz4
    },
    fonts: {
        text: "Moderat-Regular, Moderat-Light, Moderat, Helvetica, sans-serif",
        header: "Moderat-Black, Moderat-Medium, Moderat, Helvetica, sans-serif",
        baseFontSize: "16px",
    },
    borderRadius: "5px",
};
export var applyTheme = function (element, theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    element.style.setProperty("--input-color", ((_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.inputColor) || defaultTheme.colors.inputColor);
    element.style.setProperty("--button-text-color", ((_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.buttonTextColor) || defaultTheme.colors.buttonTextColor);
    element.style.setProperty("--disabled-text-color", ((_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.disabledTextColor) || defaultTheme.colors.disabledTextColor);
    element.style.setProperty("--page-color", ((_d = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _d === void 0 ? void 0 : _d.pageColor) || defaultTheme.colors.pageColor);
    element.style.setProperty("--card-color", ((_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.cardColor) || defaultTheme.colors.cardColor);
    element.style.setProperty("--text-color", ((_f = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _f === void 0 ? void 0 : _f.textColor) || defaultTheme.colors.textColor);
    element.style.setProperty("--agent-color", ((_g = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _g === void 0 ? void 0 : _g.agentColor) || defaultTheme.colors.agentColor);
    element.style.setProperty("--bot-color", ((_h = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _h === void 0 ? void 0 : _h.botColor) || defaultTheme.colors.botColor);
    element.style.setProperty("--user-color", ((_j = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _j === void 0 ? void 0 : _j.userColor) || defaultTheme.colors.userColor);
    element.style.setProperty("--link-color", ((_k = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _k === void 0 ? void 0 : _k.linkColor) || defaultTheme.colors.linkColor);
    element.style.setProperty("--button-hover-color", ((_l = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _l === void 0 ? void 0 : _l.buttonHoverColor) || defaultTheme.colors.buttonHoverColor);
    element.style.setProperty("--button-color", ((_m = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _m === void 0 ? void 0 : _m.buttonColor) || defaultTheme.colors.buttonColor);
    element.style.setProperty("--text-font", ((_o = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _o === void 0 ? void 0 : _o.text) || defaultTheme.fonts.text);
    element.style.setProperty("--header-font", ((_p = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _p === void 0 ? void 0 : _p.header) || defaultTheme.fonts.header);
    element.style.setProperty("--base-font-size", ((_q = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _q === void 0 ? void 0 : _q.baseFontSize) || defaultTheme.fonts.baseFontSize);
    element.style.setProperty("--border-radius", (theme === null || theme === void 0 ? void 0 : theme.borderRadius) || defaultTheme.borderRadius);
};
